<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出？"></QuitButton>
    </FabColumn>

    <ion-content>
      <div class="flow-content">
        <MainTitle text="職員使用" margin_top="short"></MainTitle>
        <MainSubtitle class="main-subtitle" text="請將平板電腦交給職員"></MainSubtitle>

        <InputBox text="測試者全名" placeholder="請輸入測試者全名" :value="user_info.name" @getValue="getNameValue" ref="name"></InputBox>
        <InputBox text="測試結果" hideInput="true" :value="test_result"></InputBox>

        <ConfirmButton class="flow-confirm-button" text="提交" position="relative" @click="dataEntry"></ConfirmButton>
        <TestNumber :number="user_info.number"></TestNumber>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import TestNumber from "../components/test/TestNumber";
import common from "../common";
import MainSubtitle from "../components/common/MainSubtitle";
import ConfirmButton from "../components/common/ConfirmButton";
import router from "../router";
import QuitButton from "../components/common/QuitButton";
import InputBox from "../components/common/InputBox";

export default {
  name: "NgoDataEntry",
  components: {
    InputBox,
    QuitButton,
    ConfirmButton,
    MainSubtitle,
    TestNumber,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  data() {
    return {
      name: '',
      user_info: {},
      test_result: '',
      test_id: 0,
    }
  },
  ionViewWillEnter() {
    common.getUserInfo().then(user_info => {
      this.user_info = user_info
      this.$refs.name.autoFillInput(user_info.name);

      common.getStorage('result_'+user_info.id).then(res => {
        this.test_result = res.advice_type;
      })
    })

    common.getStorage('storage_test_id').then(test_id => {
      this.test_id = test_id;
    })
  },
  methods: {
    getNameValue: function (value) {
      this.name = value
    },
    dataEntry: function () {

      if (!this.name.trim().length) {
        return common.showAlert('請輸入測試者全名。');
      }

      const loading = common.showLoading();
      common.apiPostData('/dataEntry', {
        user_id: this.user_info.id,
        test_id: this.test_id,
        name: this.name
      }, true, loading).then(res => {
        if (res === false) {
          return false;
        }
        router.replace('/credit')

      })
    }
  }
}
</script>

<style scoped>
.main-title{
  margin-top: 4vh;
}

.flow-confirm-button :deep(.relative) {
  margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
}
</style>
